module.exports = "function :example:hello(attrib, children) {\n  return (\n    <div class=\"special\">\n      <h1>Hello, World!</h1>\n      {children}\n    </div>\n  );\n}"


//////////////////
// WEBPACK FOOTER
// ./src/slides/07_jsx/xhpjs.example
// module id = 1505
// module chunks = 0